import { render, staticRenderFns } from "./AgreementDialog.vue?vue&type=template&id=200864f1&scoped=true&"
import script from "./AgreementDialog.vue?vue&type=script&lang=js&"
export * from "./AgreementDialog.vue?vue&type=script&lang=js&"
import style0 from "./AgreementDialog.vue?vue&type=style&index=0&id=200864f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200864f1",
  null
  
)

export default component.exports